import Login from './login';
import NotaSpese from './notaSpese';
import GestioneSamm from './gestioneSamm';
import GestioneAdmin from './gestioneAdmin';
import Report from './report';
import Settings from './settings';

export {
   Login,
   NotaSpese,
   GestioneSamm,
   GestioneAdmin,
   Report,
   Settings
}


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/index.js